import sdk from '@trazi/report-monitoring/sdk/node';

const reportMonitoringSDK = () => {
  const url =
    typeof window !== 'undefined'
      ? `${window.location.origin}/api`
      : process.env.REPORT_MONITORING_SERVER_URL;
  return sdk(`${url}`);
};

export default reportMonitoringSDK;
